"use strict";

$(document).ready(function() {
    var socialsharing = $(".catalogue-social-sharing"),
        sharing_name = socialsharing.data("sharingname"),
        sharing_img = socialsharing.data("sharingimg"),
        sharing_description = socialsharing.data("sharingdescription"),
        sharing_url = socialsharing.data("sharingurl");

    socialsharing.on("click", '.catalogue-social-sharing-btn', function(e) {
        var type = $(this).data("type");
        if (type.length > 1) switch (type) {
            case "twitter":
                window.open("https://twitter.com/intent/tweet?text=" + sharing_name + "&url=" + encodeURIComponent(sharing_url), "sharetwt", "toolbar=0,status=0,width=640,height=445");
                break;
            case "facebook":
                window.open("https://www.facebook.com/sharer.php?u=" + sharing_url, "sharefcbk", "toolbar=0,status=0,width=660,height=445");
                break;
            case "whatsapp":
                window.open("https://wa.me/?text=" + sharing_url);
                break;
            case "pinterest":
                window.open("https://www.pinterest.com/pin/create/button/?media=" + sharing_img + "&description=" + sharing_description + "&url=" + sharing_url, "sharepin", "toolbar=0,status=0,width=660,height=445")
        }
    })
});
